import React, { useState , useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { ArrowLeft } from 'lucide-react';
import '../../../assets/css/general/forgetpassword/ForgetPassword.css';
import StepEmail from '../../../subscreens/general/stepemail/StepEmail';
import StepOtp from '../../../subscreens/general/stepotp/StepOtp';
import StepNewPassword from '../../../subscreens/general/stepnewpassword/StepNewPassword';
import StepSuccess from '../../../subscreens/general/stepsuccess/StepSuccess';
import AppContext from '../../../context/AppContext';


const ForgetPassword = () => {
    const navigate = useNavigate();
  const [step, setStep] = useState(1); 
  const { baseUrl } = useContext(AppContext);

  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
const [otpError, setOtpError] = useState("");
const [passwordError, setPasswordError] = useState("");

  const totalSteps = 4;
// send otp
const handleSendOtp = () => {

  setEmailError("");

  if (!email.trim()) {
    setEmailError("Email is required.");
    return;
  }

  setLoading(true);

  axios.post(`${baseUrl}/customer/send-reset-otp`, {
    email: email
  })
  .then((res) => {
    setStep(2);
  })
  .catch((err) => {

    if (err.response?.data?.errors?.email) {
      setEmailError(err.response.data.errors.email[0]);
    } else {
      // setEmailError(err.response?.data?.message || "Something went wrong.");
    }

  })
  .finally(() => {
    setLoading(false);
  });

};
// verify
const handleVerifyOtp = () => {

  setOtpError("");

  if (!otp.trim()) {
    setOtpError("OTP is required.");
    return;
  }

  setLoading(true);

  axios.post(`${baseUrl}/customer/verify-reset-otp`, {
    email,
    otp
  })
  .then(() => {
    setStep(3);
  })
  .catch((err) => {

    if (err.response?.data?.errors?.otp) {
      setOtpError(err.response.data.errors.otp[0]);
    } else {
      setOtpError(err.response?.data?.message || "Invalid OTP.");
    }

  })
  .finally(() => {
    setLoading(false);
  });

};

// reset password
const handleResetPassword = (newPassword, confirmPassword) => {

  setPasswordError("");

  if (!newPassword || newPassword.length < 8) {
    setPasswordError("Password must be at least 8 characters.");
    return;
  }

  if (newPassword !== confirmPassword) {
    setPasswordError("Passwords do not match.");
    return;
  }

  setLoading(true);

  axios.post(`${baseUrl}/customer/reset-password`, {
    email,
    otp,
    password: newPassword
  })
  .then(() => {
    setStep(4);
  })
  .catch((err) => {

    if (err.response?.data?.errors?.password) {
      setPasswordError(err.response.data.errors.password[0]);
    } else {
      setPasswordError(err.response?.data?.message || "Password reset failed.");
    }

  })
  .finally(() => {
    setLoading(false);
  });

};

  const handleResendOtp = () => {
    handleSendOtp();
  };

  const goBackStep = () => {
    if (step === 1) {
      navigate(-1);
    } else {
      setStep((s) => s - 1);
    }
  };

  return (
    <div className="fp-page">
      <div className="fp-card">

        {/* Header */}
        <div className="fp-header">
          <button className="fp-back-btn" onClick={goBackStep}>
            <ArrowLeft size={20} />
          </button>
          <h2 className="fp-title">Forgot Password</h2>
        </div>

        {/* Progress dots */}
        {step < 4 && (
          <div className="fp-progress">
            {Array.from({ length: 3 }).map((_, i) => (
              <div
                key={i}
                className={'fp-progress__dot' + (i + 1 <= step ? ' fp-progress__dot--active' : '')}
              />
            ))}
          </div>
        )}

        {/* Steps */}
        {step === 1 && (
          <StepEmail
    email={email}
    setEmail={setEmail}
    emailError={emailError}
    onNext={handleSendOtp}
    loading={loading}
/>
        )}

        {step === 2 && (
          <StepOtp
    email={email}
    otp={otp}
    setOtp={setOtp}
    otpError={otpError}
    onNext={handleVerifyOtp}
    onResend={handleResendOtp}
    loading={loading}
/>
        )}

        {step === 3 && (
         <StepNewPassword
    passwordError={passwordError}
    onSubmit={handleResetPassword}
    loading={loading}
/>
        )}

        {step === 4 && (
          <StepSuccess
            onGoToLogin={() => navigate('/login')}
          />
        )}

      </div>
    </div>
  );
};

export default ForgetPassword;